module.exports = __webpack_public_path__ + "img/3EA78C60.410894b2.png";